import { useParams, Navigate, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { CropWidget } from "@/components/crop/CropWidget";
import { ToolContent } from "@/components/ToolContent";
import { AdUnit } from "@/components/AdUnit";
import { ToolIcon } from "@/components/iconMap";
import { CROP_TOOLS } from "@/data/tools";

const PRIMARY_LABEL = {
  amazon: "Start Amazon Crop",
  flipkart: "Start Flipkart Crop",
  meesho: "Start Meesho Crop",
};

export default function CropToolPage() {
  const { slug } = useParams();
  const cfg = CROP_TOOLS[slug];
  if (!cfg) return <Navigate to="/ecommerce-tools" replace />;

  let primaryLabel = "Start crop";
  if (cfg.mode === "marketplace") primaryLabel = cfg.slug === "shopsy-shipping-label-crop" ? "Start Shopsy Crop" : PRIMARY_LABEL[cfg.market];
  else if (cfg.mode === "merge") primaryLabel = "Merge labels";
  else if (cfg.mode === "a4") primaryLabel = "Make A4 sheets";
  else if (cfg.mode === "invoice") primaryLabel = "Crop invoices";

  return (
    <>
      <Seo
        title={cfg.metaTitle}
        description={cfg.metaDesc}
        path={cfg.path}
        faq={cfg.faq}
        breadcrumb={[
          { name: "Home", path: "/" },
          { name: "Ecommerce Tools", path: "/ecommerce-tools" },
          { name: cfg.name, path: cfg.path },
        ]}
      />

      <section className="relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 grid-dots opacity-10" />
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12">
          <nav className="flex items-center gap-2 text-xs text-slate-400 mb-6" data-testid="breadcrumb">
            <Link to="/" className="hover:text-white">Home</Link>
            <ChevronRight className="w-3 h-3" />
            <Link to="/ecommerce-tools" className="hover:text-white">Ecommerce Tools</Link>
            <ChevronRight className="w-3 h-3" />
            <span className="text-slate-200">{cfg.name}</span>
          </nav>
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center shrink-0">
              <ToolIcon name={cfg.icon} className="w-7 h-7 text-blue-300" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{cfg.name}</h1>
              <p className="mt-3 text-lg text-slate-300 max-w-2xl leading-relaxed">{cfg.promise}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="relative -mt-6 pb-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <CropWidget mode={cfg.mode} market={cfg.market} primaryLabel={primaryLabel} />
          <AdUnit />
        </div>
      </section>

      <ToolContent cfg={cfg} />
    </>
  );
}
